// extracted by mini-css-extract-plugin
module.exports = {"headerColumn":"style_headerColumn__jwTpL","rowColumn":"style_rowColumn__3bg6H","feedName":"style_feedName__3S__P"};